import React, {ReactElement, ReactNode} from 'react';
import {Wrapper, Placeholder, Control} from './style';

interface SelectProps {
  text: string | number;
  value: string | number;
  children: ReactNode;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

export const Select = ({text, children, ...props}: SelectProps): ReactElement => (
  <Wrapper>
    <Placeholder data-test='placeholder'>{text}</Placeholder>
    <Control data-test='control' {...props}>
      {children}
    </Control>
  </Wrapper>
);
